// extracted by mini-css-extract-plugin
module.exports = {"filters":"styles_filters__Y6ytQ","default":"styles_default__JrX5E"};